import { maxWidth } from '@creatic/reactic-styles';
import styled from 'styled-components';

export const StyledLabel = styled.span`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 16px;
  font-size: ${({ theme }) => theme.size.palantir};
  font-weight: ${({ theme }) => theme.weight.semibold};
  line-height: 1;
  color: ${({ theme }) => theme.color.grey21};
  white-space: nowrap;
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.grey88};
  border-radius: 20px;
  box-shadow: ${({ theme }) => theme.shadow.launcher};
  transition: border-color 200ms linear;

  @media ${maxWidth.tablet} {
    display: none;
  }
`;

export const StyledBubble = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.metric.launcherSize};
  height: ${({ theme }) => theme.metric.launcherSize};
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.grey88};
  border-radius: 50%;
  box-shadow: ${({ theme }) => theme.shadow.launcher};
  transition:
    transform 200ms ease,
    border-color 200ms linear;
`;

export const StyledIcon = styled.img`
  display: block;
  width: 40px;
  height: 40px;
  object-fit: contain;
`;

export const StyledLauncher = styled.button`
  position: fixed;
  right: ${({ theme }) => theme.metric.offset};
  bottom: ${({ theme }) => theme.metric.offset};
  z-index: ${({ theme }) => theme.zIndex.widget};
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 0;
  margin: 0;
  font: inherit;
  cursor: pointer;
  background: none;
  border: none;

  &:hover {
    ${StyledLabel},
    ${StyledBubble} {
      border-color: ${({ theme }) => theme.color.grey68};
    }

    ${StyledBubble} {
      transform: translateY(-2px);
    }
  }

  &:focus-visible {
    outline: none;

    ${StyledBubble} {
      border-color: ${({ theme }) => theme.color.violet64};
    }
  }
`;
